export const SHIP_STATUS = {
  da_preparare: { label: "Da preparare", tone: "#94A3B8" },
  in_preparazione: { label: "In preparazione", tone: "#7C3AED" },
  in_attesa_spedizione: { label: "In attesa di spedizione", tone: "#F59E0B" },
  spedito: { label: "Spedito", tone: "#2DD4BF" },
  in_transito: { label: "In transito", tone: "#38BDF8" },
  consegnato: { label: "Consegnato", tone: "#22C55E" },
  ricezione_confermata: { label: "Ricezione confermata", tone: "#10B981" },
  problema_segnalato: { label: "Problema segnalato", tone: "#EF4444" },
};

export const PROGRESS = ["da_preparare", "in_preparazione", "in_attesa_spedizione", "spedito", "in_transito", "consegnato", "ricezione_confermata"];

export const fmtDate = (v) => (v ? new Date(v).toLocaleDateString("it-IT") : "—");

export const copyText = async (text, label = "Copiato") => {
  try { await navigator.clipboard.writeText(text); return label; } catch { return null; }
};
